// src/pages/Promociones.js
import React, { useEffect, useState } from "react";
import { db } from "../config/firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Promociones() {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const snap = await getDocs(collection(db, "promociones"));
        const data = snap.docs.map((d) => {
          const p = d.data();
          let imageUrl =
            p.image || p.imagen || "https://via.placeholder.com/300";
          if (
            imageUrl.includes("imgur.com") &&
            !imageUrl.includes("i.imgur.com")
          ) {
            imageUrl = imageUrl.replace("imgur.com", "i.imgur.com");
            if (!imageUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i))
              imageUrl += ".jpg";
          }
          return {
            id: d.id,
            title: p.title || p.titulo || "Sin título",
            image: imageUrl,
            link: p.link || p.enlace || "#",
            badge: p.badge || p.etiqueta || "Oferta",
          };
        });
        setPromotions(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  return (
    <div
      style={{
        background: "#F5F5F5",
        minHeight: "100vh",
        fontFamily: "'Nunito', sans-serif",
      }}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap"
        rel="stylesheet"
      />

      {/* Señal de carga completa para el pre-renderizador */}
      {!loading && <div id="snap-ready" style={{ display: "none" }}></div>}

      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #FF6B35, #E91E8C)",
          padding: "28px 20px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            color: "#fff",
            fontWeight: 900,
            fontSize: "clamp(1.5rem, 4vw, 2.2rem)",
            margin: "0 0 8px",
          }}
        >
          🔥 Promociones del Día
        </h1>
        <p
          style={{
            color: "rgba(255,255,255,0.85)",
            margin: 0,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          Ofertas exclusivas por tiempo limitado ⚡
        </p>
      </div>

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 16px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <div
              style={{
                display: "inline-block",
                width: 44,
                height: 44,
                border: "5px solid #f3f3f3",
                borderTop: "5px solid #E91E8C",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            <p style={{ marginTop: 16, color: "#666", fontWeight: 600 }}>
              Cargando promociones...
            </p>
          </div>
        ) : promotions.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px",
              background: "#fff",
              borderRadius: 16,
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: 12 }}>😕</div>
            <h3 style={{ fontWeight: 800, color: "#333" }}>
              No hay promociones activas
            </h3>
            <p style={{ color: "#666" }}>
              Vuelve pronto para ver nuevas ofertas
            </p>
          </div>
        ) : (
          <>
            <p
              style={{
                color: "#666",
                fontWeight: 700,
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              {promotions.length} promoción{promotions.length !== 1 ? "es" : ""}{" "}
              disponible{promotions.length !== 1 ? "s" : ""}
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: 16,
              }}
            >
              {promotions.map((p) => (
                <a
                  key={p.id}
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: 12,
                      overflow: "hidden",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 24px rgba(0,0,0,0.14)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 2px 10px rgba(0,0,0,0.08)";
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={p.image}
                        alt={p.title}
                        style={{
                          width: "100%",
                          height: 200,
                          objectFit: "cover",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 10,
                          left: 10,
                          background:
                            "linear-gradient(135deg, #FF6B35, #E91E8C)",
                          color: "#fff",
                          padding: "4px 12px",
                          borderRadius: 20,
                          fontSize: "0.75rem",
                          fontWeight: 900,
                        }}
                      >
                        {p.badge}
                      </div>
                    </div>
                    <div style={{ padding: "14px 14px 16px" }}>
                      <div
                        style={{
                          fontWeight: 800,
                          fontSize: "0.92rem",
                          color: "#1a1a1a",
                          marginBottom: 10,
                          lineHeight: 1.3,
                        }}
                      >
                        {p.title}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                          background:
                            "linear-gradient(135deg, #FF6B35, #E91E8C)",
                          color: "#fff",
                          padding: "10px",
                          borderRadius: 8,
                          fontWeight: 900,
                          fontSize: "0.88rem",
                        }}
                      >
                        VER OFERTA AHORA 👉
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
